/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TicketScanUndoRequest
 */
export interface TicketScanUndoRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketScanUndoRequest
     */
    ticketCode: string;
}

/**
 * Check if a given object implements the TicketScanUndoRequest interface.
 */
export function instanceOfTicketScanUndoRequest(value: object): value is TicketScanUndoRequest {
    if (!('ticketCode' in value) || value['ticketCode'] === undefined) return false;
    return true;
}

export function TicketScanUndoRequestFromJSON(json: any): TicketScanUndoRequest {
    return TicketScanUndoRequestFromJSONTyped(json, false);
}

export function TicketScanUndoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketScanUndoRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ticketCode': json['ticketCode'],
    };
}

export function TicketScanUndoRequestToJSON(json: any): TicketScanUndoRequest {
    return TicketScanUndoRequestToJSONTyped(json, false);
}

export function TicketScanUndoRequestToJSONTyped(value?: TicketScanUndoRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ticketCode': value['ticketCode'],
    };
}

